import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { AppPermission, Permission } from 'src/app/shared/interface/common.interface';
import { AccessControlState } from 'src/app/shared/state/access-control.state';
import { UserState } from 'src/app/shared/state/user.state';

@Directive({
  selector: '[showIfPermitted]',
  standalone: true,
})
export class ShowIfPermittedDirective {
  private _action: Permission | null = null;
  private _permittedActions: Permission[] | null = null;

  @Input('showIfPermitted') set showIfPermitted(action: Permission) {
    this._action = action;
    this._updateView();
  }

  @Input('showIfPermittedIn') set showIfPermittedIn(actions: Permission[]) {
    this._permittedActions = actions;
    this._updateView();
  }

  constructor(
    private templateRef: TemplateRef<unknown>,
    private viewContainer: ViewContainerRef,
    private userState: UserState,
    private accessControlState: AccessControlState
  ) {}

  private _updateView() {
    this.viewContainer.clear();

    if (!this._action) return;

    const actionsToCheck: Permission[] =
      this._permittedActions ??
      (Object.values(AppPermission).includes(this._action as AppPermission)
        ? this.userState.permittedActions
        : this.accessControlState.permittedActions);

    if (actionsToCheck?.includes(this._action)) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }
}
